// material-ui
import { useTheme } from '@mui/material/styles';
import Logo from '../logo/logo.svg'

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();
  return (
    <>
      <img src={Logo} alt="" srcset="" height={40} />
    </>
  );
}
